import { ParsedUrlQuery } from 'querystring'

export const setFilterFromQuery = (query: ParsedUrlQuery) => query['filter'] as string | undefined
